// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__kbXVd"};